module.exports = __webpack_public_path__ + "img/setting.813e79e0.svg";